import { JetDetailsCitationConfig } from '@/types/jetDetails.types';
import styles from './jetDetails.module.scss';
import Image from 'next/image';

const JetDetails = ({
  citationConfig,
}: {
  citationConfig: JetDetailsCitationConfig;
}) => {
  return (
    <section className="container">
      <div className={styles.jetDetails}>
        <h2 className={styles.jetDetailsTitle}>Details</h2>
        <div className={styles.jetDetailsContent}>
          <div className={styles.jetDetailsLineMaineTitle}>
            General Capacity
          </div>
          <div className={styles.jetDetailsLineItems}>
            {citationConfig.items.GeneralCapacity.map((item) => (
              <div key={item.id} className={styles.jetDetailsLine}>
                <Image
                  src={'img/details/check-circled.svg'}
                  alt={item.title}
                  width={24}
                  height={24}
                />
                <div className={styles.jetDetailsLineTitle}>
                  {item.title}
                  <span className={styles.jetDetailsLineValue}>
                    {item.value}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className={styles.jetDetailsContent}>
          <div className={styles.jetDetailsLineMaineTitle}>
            Luggage Capacity
          </div>
          <div className={styles.jetDetailsLineItems}>
            {citationConfig.items.LuggageCapacity.map((item) =>
              item.id === 2 ? (
                <div key={item.id} className={styles.jetDetailsLine}>
                  <Image
                    src={'img/details/check-circled.svg'}
                    alt={item.title}
                    width={24}
                    height={24}
                  />
                  <div className={styles.jetDetailsLineTitle}>
                    <span className={styles.jetDetailsLineValue}>
                      {item.title} {item.value}
                    </span>
                  </div>
                </div>
              ) : (
                <div key={item.id} className={styles.jetDetailsLine}>
                  <Image
                    src={'img/details/check-circled.svg'}
                    alt={item.title}
                    width={24}
                    height={24}
                  />
                  <div className={styles.jetDetailsLineTitle}>
                    {item.title}{' '}
                    <span className={styles.jetDetailsLineValue}>
                      {item.value}
                    </span>
                  </div>
                </div>
              )
            )}
          </div>
        </div>

        <div className={styles.jetDetailsContent}>
          <div className={styles.jetDetailsLineMaineTitle}>Cabin Specs</div>
          <div className={styles.jetDetailsLineItems}>
            {citationConfig.items.CabinSpecs.map((item) => (
              <div key={item.id} className={styles.jetDetailsLine}>
                <Image
                  src={'img/details/check-circled.svg'}
                  alt={item.title}
                  width={24}
                  height={24}
                />
                <div className={styles.jetDetailsLineTitle}>
                  {item.title}
                  <span className={styles.jetDetailsLineValue}>
                    {item.value}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default JetDetails;
